export default function DownloadReportDirective() {
  return {
    restrict: 'E',
    template: require('./download-report.directive.html'),
    scope: {
      reportInstanceId: '@',
      tooltip: '@',
      tooltipAppendToSelector: '@',
      iconType: '@',
      iconSizeClass: '@',
      iconColorClass: '@',
    },
    controller: 'DownloadReportDirectiveController',
    controllerAs: 'downloadReportVM',
    bindToController: true,
    replace: true,
  };
}
